export default [
  'onesize',
  'xs',
  's',
  'm',
  'l',
  'xl',
  'xxl',
  '2xl',
  '100',
  '110',
  '120',
  '130',
  '140',
  '150',
  '160',
  '110/116',
  '122/128',
  '134/140',
  '146/152',
  '158/164',
  '35-37',
  '38-40',
  '41-43',
  '44-46',
  '25-28',
  '25-35',
  '29-32',
  '33-36',
  '36-46',
  '25-28',
  '29-32',
  '33-36',
  '29-31',
  '32-34',
  '35-38',
  '39-42',
  '43-46',
  'xs/s',
  's/m',
  'm/l',
  'l/xl',
  'xl/xxl',
];
